import { InfoCircleOutlined } from '@ant-design/icons';
import { useState } from 'react';

import Input from '@/components/Inputs/Input';
import PasswordInput from '@/components/Inputs/PasswordInput';
import { useModalContext } from '@/components/Modal/Modal';
import Typo from '@/components/Typography/Typo';
import { isEmptyString } from '@/utils/util';

import { CompoundConnectModal } from '../../components/ConnectModal';

type Props = {
  onConnect: (params: { apiKey: string; apiSecret: string }) => Promise<unknown>;
  onConnectComplete: () => void;
};

export const KnocommerceConnectModal = (props: Props) => {
  const { closeModal } = useModalContext();

  const [apiKey, setApiKey] = useState('');
  const [apiSecret, setApiSecret] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleConnectWorkspace = async () => {
    if (isEmptyString(apiKey) || isEmptyString(apiSecret)) {
      setError('Please enter both API Key and API Secret');
      return;
    }

    setError(null);

    try {
      await props.onConnect({
        apiKey: apiKey.trim(),
        apiSecret: apiSecret.trim(),
      });
      props.onConnectComplete();
      closeModal();
    } catch (e) {
      if (e instanceof Error) {
        setError(e.message);
        return;
      }
      setError('Failed to connect to Knocommerce. Please try again.');
    }
  };

  const isApiKeyValid = !isEmptyString(apiKey) && !isEmptyString(apiSecret);

  return (
    <CompoundConnectModal
      title="Connect Knocommerce"
      description="Access key and access secret are required to connect to Knocommerce."
      error={error}
      connectButtonDisabled={!isApiKeyValid}
      handleConnectWorkspace={handleConnectWorkspace}
    >
      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-2">
          <Typo type="label2" weight="sb">
            Access key
          </Typo>
          <div
            className="flex items-center gap-1 cursor-pointer text-sm text-gray-600"
            onClick={() => window.open('https://developers.knocommerce.com/')}
          >
            How to get your Access key and Access secret
            <InfoCircleOutlined className="text-primary size-3.5" />
          </div>
          <Input
            placeholder="type access key"
            sizeType="m"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
          />
          <Typo type="label2" weight="sb">
            Access secret
          </Typo>
          <PasswordInput
            sizeType="m"
            placeholder="type access secret"
            name="accessSecret"
            value={apiSecret}
            onChange={(e) => setApiSecret(e.target.value)}
          />
        </div>
      </div>
    </CompoundConnectModal>
  );
};
